module.exports = __webpack_public_path__ + "img/3d-car.d9076964.png";